var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-select-seat-sticker"},[_c('el-button',{staticClass:"grid-menu-item",attrs:{"loading":_vm.loading},on:{"click":_vm.handlePrint}},[_c('i',{staticClass:"iconfont icon-printer"}),_c('span',{staticClass:"text-span"},[_vm._v("打印座位标贴")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }